export let searchButtonAriaLabel = "hpqLid";
export default {searchButtonAriaLabel};